import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, ButtonToolbar, Modal, Table,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

import Alert from '../../../../shared/components/Alert';
import CommonService from '../../../../services/CommonService';
import global from '../../../../global';

class InventoryReport extends PureComponent {
  static propTypes = {
    modal: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    postValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    modal: false,
    postValue: {},
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
    errorMsg: '',
  };

  constructor(props) {
    super(props);
    const { postValue } = this.props;
    this.state = {
      modal: false,
      listbaches: {},
      productName: '',
    };

    this.productId = postValue.productid;
    this.isLoading = false;
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadInventory();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.modal === true) {
      this.productId = nextProps.postValue.productid;
      this.onLoadInventory();
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadInventory = async () => {
    try {
       const { postValue } = this.props;
       const response = await CommonService.getRows(`getreportbatches/productid/${this.productId}/locationid/${postValue.locationid}`);
       if (response.result !== false) {
        this.setState({ listbaches: response.list, productName: response.product_name });
       }
    } catch (err) {
       console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      listbaches, productName,
    } = this.state;

    const {
      modal, toggle, handleSubmit, errorMsg,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header modal-lg"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">Inventory Report {productName !== '' ? ` - ${productName}` : ''}</h4>
          </div>
          <form id="warehouseInventoryReport_form" onSubmit={handleSubmit}>
            <div className="modal__body">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                  </Alert>
                </div>
                )
              }

              <div className="form">
                <Table className="gray_hover">
                  <thead>
                    <tr>
                      <th>Reference No</th>
                      <th className="text-center">Batch Code</th>
                      <th className="text-center">Remaining Quantity</th>
                      <th className="text-center">Actual Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listbaches.length > 0 && listbaches.map(item => (
                        <tr key={item.batch_id}>
                          <td data-tx="Reference No"> <span>{item.reference_number}</span> </td>
                          <td className="text-center" data-tx="Batch Code"> <span>{item.batch_code}</span> </td>
                          <td className="text-center" data-tx="Remaining Quantity"> <span>{global.numberFormat(item.balance_new, 0)} kgs.</span> </td>

                          <td className="text-center" data-tx="Actual Quantity">
                            <input type="text" name={`batchquantity[${item.batch_id}]`} placeholder="Actual quantity..." />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>

                <div className="form form--vertical m-t-10 full-width">
                  <div className="form__form-group m-b-0">
                    <span className="form__form-group-label">Note</span>
                    <div className="form__form-group-field">
                        <textarea name="note" placeholder="Note" className="mh-95 no-resize" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ButtonToolbar className="modal__footer m-t-10">
              <Button color="info">Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'warehouse_insertInventory', // a unique identifier for this form
})(withTranslation('common')(InventoryReport));
